import { useEffect, useState } from "react";
import api from "../api/PosApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DataTable from "react-data-table-component";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";

const MySwal = withReactContent(Swal);

export default function Emisiones() {
    const [documentos, setDocumentos] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const cargarPendientes = async () => {
        setLoading(true);
        try {
            const res = await api.get("/pos/ventas");
            const docs = res.data.filter(
                (d: any) => d.estadoMH === "CREADO" || d.estadoMH === "ERROR_ENVIO"
            );
            setDocumentos(docs);
        } catch {
            MySwal.fire("Error", "❌ No se pudieron cargar los documentos", "error");
        } finally {
            setLoading(false);
        }
    };

    const emitir = async (id: string) => {
        try {
            const res = await api.post(`/pos/ventas/${id}/emitir`);
            MySwal.fire({
                icon: "success",
                title: "Documento emitido",
                text: `Estado: ${res.data.estado}`,
                timer: 2500,
                showConfirmButton: false,
            });
            cargarPendientes();
        } catch {
            MySwal.fire("Error", "❌ No se pudo emitir el documento", "error");
        }
    };

    const invalidar = async (id: string) => {
        const confirm = await MySwal.fire({
            title: "¿Invalidar este documento?",
            text: "Esto marcará el documento como anulado internamente.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, invalidar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
        });
        if (!confirm.isConfirmed) return;

        try {
            const res = await api.post(`/pos/ventas/${id}/invalidar`);
            MySwal.fire({
                icon: "info",
                title: "Documento invalidado",
                text: `Estado: ${res.data.estado}`,
                timer: 2500,
                showConfirmButton: false,
            });
            cargarPendientes();
        } catch {
            MySwal.fire("Error", "❌ No se pudo invalidar el documento", "error");
        }
    };

    useEffect(() => {
        cargarPendientes();
    }, []);

    const columnas = [
        {
            name: "Fecha",
            selector: (row: any) => new Date(row.fechaEmision).toLocaleDateString(),
            sortable: true,
            width: "120px",
        },
        { name: "Cliente", selector: (row: any) => row.clienteNombre, sortable: true },
        {
            name: "Tipo DTE",
            selector: (row: any) =>
                row.tipoDte === "01"
                    ? "Factura"
                    : row.tipoDte === "03"
                        ? "Crédito Fiscal"
                        : row.tipoDte === "05"
                            ? "Nota de Crédito"
                            : "",
        },
        {
            name: "Total",
            selector: (row: any) => `$${row.totalPagar.toFixed(2)}`,
            sortable: true,
            right: true,
        },
        { name: "Estado MH", selector: (row: any) => row.estadoMH },
        {
            name: "Acciones",
            cell: (row: any) => (
                <div className="d-flex gap-2">
                    <Button size="sm" variant="success" onClick={() => emitir(row.id)}>
                        Emitir
                    </Button>
                    <Button size="sm" variant="danger" onClick={() => invalidar(row.id)}>
                        Invalidar
                    </Button>
                </div>
            ),
        },
    ];

    const customStyles = {
        table: {
            style: { backgroundColor: "#121212" },
        },
        headCells: {
            style: {
                backgroundColor: "#1e1e1e",
                color: "#fff",
                fontWeight: "bold",
            },
        },
        rows: {
            style: {
                backgroundColor: "#181818",
                color: "#e0e0e0",
                "&:hover": { backgroundColor: "#222" },
                padding: "1rem"
            },
        },
        pagination: {
            style: {
                backgroundColor: "#121212",
                color: "#ccc",
            },
        },
    };

    return (
        <Container className="mt-4">
            <Card className="card-black">
                <Card.Header>
                    <h3 className="text-light">Documentos Pendientes de Emisión</h3>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            {loading ? (
                                <div className="text-center text-light mt-5">
                                    <Spinner animation="border" variant="light" />
                                    <p className="mt-3">Cargando documentos...</p>
                                </div>
                            ) : (
                                <DataTable
                                    columns={columnas}
                                    data={documentos}
                                    pagination
                                    highlightOnHover
                                    dense
                                    customStyles={customStyles}
                                    fixedHeader
                                    fixedHeaderScrollHeight="500px"
                                    noDataComponent="No hay documentos pendientes"
                                    paginationPerPage={8}
                                />
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

        </Container>
    );
}
